export default __webpack_public_path__ + "static/help_06_04-4-ff48d7cdac5391dc04f5061286cef28a.png";